import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The RegionalProviders's component.
 */
const RegionalProviders = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-InfoRegional-Proveedores.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Botón para volver a la tabla de proveedores del año seleccionado.</Item>
        <Item>Selecciona el tipo de vista que deseas para los datos, ya sea visualización o tabla de datos.</Item>
        <Item>Eje correspondiente a los montos transados en millones de pesos.</Item>
        <Item>
          La burbuja representa la cantidad de montos transados y número de órdenes de compra entre el proveedor y la
          región. Mientras más arriba la burbuja mayor el monto y mientras más grande mayor el número de órdenes de
          compra.
        </Item>
        <Item>Eje correspondiente a todos los meses del año.</Item>
        <Item>Información del proveedor.</Item>
        <Item>Accedo a la ficha pública del proveedor.</Item>
        <Item>Botón para descargar los datos que se están visualizando.</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default RegionalProviders
